document.addEventListener('DOMContentLoaded', function() {
// --- V5 SCRIPT: DYNAMIC PANEL REVEAL ---

// Get all triggers and elements
const desktopMenuTrigger = document.querySelector('#desktop-menu-trigger');
const megaMenuContainer = document.getElementById('custom-mega-menu-container');
const rightPanel = document.querySelector('.custom-mega-menu__right-panel'); // --- NEW --- Get the right panel
const closeButton = document.querySelector('.custom-mega-menu__close-button');
const leftPanelItems = document.querySelectorAll('.custom-mega-menu__nav-item');
const mainMenuItems = document.querySelectorAll('#AccessibleNav a.dt-sc-nav-link');
const mobileBreakpoint = 990;

// --- MODIFIED: Function now decides whether to show the right panel on open ---
function openMegaMenu(activeHandle = null, showRightPanelImmediately = true) {
  if (!megaMenuContainer) return;

  megaMenuContainer.classList.add('is-visible');
  document.body.style.overflow = 'hidden';

  // Reset all items and panels first
  leftPanelItems.forEach(item => item.classList.remove('is-active'));
  document.querySelectorAll('.custom-mega-menu__content-panel').forEach(p => p.style.display = 'none');

  // --- MODIFIED: Logic to handle panel visibility ---
  if (showRightPanelImmediately) {
    // This is for clicks on main nav links like "Men's", "Brands", etc.
    megaMenuContainer.classList.remove('right-panel-hidden');

    let handleToActivate = activeHandle;
    // If for some reason no handle is passed, default to the first one
    if (!handleToActivate && leftPanelItems.length > 0) {
      handleToActivate = leftPanelItems[0].dataset.menuHandle;
    }

    if (handleToActivate) {
      const itemToActivate = document.querySelector(`.custom-mega-menu__nav-item[data-menu-handle="${handleToActivate}"]`);
      const panelToActivate = document.getElementById(handleToActivate);
      if (itemToActivate) itemToActivate.classList.add('is-active');
      if (panelToActivate) panelToActivate.style.display = 'block';
    }
  } else {
    // This is for the hamburger icon click - show only the left panel initially
    megaMenuContainer.classList.add('right-panel-hidden');
  }
}

function closeMegaMenu() {
  if (megaMenuContainer) {
    megaMenuContainer.classList.remove('is-visible');
    document.body.style.overflow = '';
    // --- MODIFIED: Ensure the right panel is hidden for the next hamburger click ---
    // We add a small delay to let the closing animation finish first
    setTimeout(() => {
        megaMenuContainer.classList.add('right-panel-hidden');
    }, 300);
  }
}

// --- DESKTOP EVENT LISTENERS ---

// Listener for the NEW desktop-only hamburger icon
if (desktopMenuTrigger) {
  desktopMenuTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    // --- MODIFIED: Open with only the left panel visible ---
    openMegaMenu(null, false);
  });
}

// Listeners for the main navigation links (e.g., "Brands")
mainMenuItems.forEach(link => {
  const handle = link.dataset.handle;
  const correspondingPanel = document.getElementById(handle);
  if (correspondingPanel) {
    link.addEventListener('click', (e) => {
      if (window.innerWidth >= mobileBreakpoint) {
        e.preventDefault();
        // --- MODIFIED: Open with both panels visible immediately ---
        openMegaMenu(handle, true);
      }
    });
  }
});

// Listeners for closing the mega menu
if (closeButton) closeButton.addEventListener('click', closeMegaMenu);
if (megaMenuContainer) {
  megaMenuContainer.addEventListener('click', (e) => {
    if (e.target === megaMenuContainer) closeMegaMenu();
  });
}

// Listener for hovering over left panel items
leftPanelItems.forEach(item => {
  item.addEventListener('mouseover', () => {
    // --- MODIFIED: Reveal the right panel on the first hover ---
    if (megaMenuContainer.classList.contains('right-panel-hidden')) {
        megaMenuContainer.classList.remove('right-panel-hidden');
    }

    // The rest of the logic remains the same
    leftPanelItems.forEach(other => other.classList.remove('is-active'));
    item.classList.add('is-active');
    document.querySelectorAll('.custom-mega-menu__content-panel').forEach(p => p.style.display = 'none');
    const panelId = item.dataset.menuHandle;
    const activePanel = document.getElementById(panelId);
    if (activePanel) activePanel.style.display = 'block';
  });
});


// --- MOBILE EVENT LISTENER (No changes needed) ---
const mobileDetails = document.querySelectorAll('.mobile-nav__details');
mobileDetails.forEach(detail => {
  detail.addEventListener('toggle', () => {
    if (detail.open) {
      const parent = detail.closest('ul, .mobile-nav__submenu');
      if (parent) {
        parent.querySelectorAll('.mobile-nav__details[open]').forEach(openDetail => {
          if (openDetail !== detail) openDetail.removeAttribute('open');
        });
      }
    }
  });
});
});